import React from 'react';
import LoginButton from '../components/LoginButton';
import TopBody from '../components/TopBody';
import LinkElement from '../components/LinkElement';

import barista from '../assets/images/baristas.jpg';
import runner from '../assets/images/runners.jpg';
import manager from '../assets/images/managers.jpg';
import chef from '../assets/images/chefs.jpg';
import config from '../config/constants';
import PoweredBy from '../components/PoweredBy';
import IFrameService from '../service/IFrameService';

export default class Home extends React.Component{
	
	componentDidMount = () => {
		IFrameService.parentData();
	};
	
	componentDidUpdate = () => {
		IFrameService.parentData();
	};
	
	render = () => {
		
		return (
			<div className="container">
				<LoginButton/>
				<TopBody className="rcg-top-standard" header={'We are hiring'} title={'Vacancies'}/>
				
				<div className="flex-parent rcg-home-upload-button">
					<div className="flex-child">
						<LinkElement href={`${config.PROTOCOL}://${config.DOMAIN}/register`} taget="__blank" label={'Upload CV here'}/>
					</div>
				</div>
				
				<div className="flex-parent">
					
					<div className="flex-child-columns">
						<a href="/vacancies/chef" className="flex-block">
							<img src={chef} alt="Chefs"/>
							<div className="flex-block cover-absolute">
								<h3>Chefs</h3>
							</div>
						</a>
						<a href="/vacancies/manager" className="flex-block">
							<img src={manager} alt="Managers"/>
							<div className="flex-block cover-absolute">
								<h3>Managers</h3>
							</div>
						</a>
					</div>
				</div>
				
				<div className="flex-parent">
					
					<div className="flex-child-columns">
						<a href="/vacancies/barista" className="flex-block block-left">
							<img src={barista} alt="Baristas"/>
							<div className="flex-block cover-absolute">
								<h3>Baristas</h3>
							</div>
						</a>
						<a href="/vacancies/runner" className="flex-block block-right">
							<img src={runner} alt="Runners"/>
							<div className="flex-block cover-absolute">
								<h3>Runners</h3>
							</div>
						</a>
					</div>
					
				</div>
				
				<PoweredBy />
				
			</div>
		);
	};
}


// WEBPACK FOOTER //
// ./src/pages/Home.js